import { invocationName } from './utils.js';

async function compileGJSArray(js, importMap) {
  const modules = await Promise.all(js.map(async ({
    code
  }) => {
    return await compileGJS(code, importMap);
  }));
  return modules;
}
async function compileGJS(gjsInput, importMap) {
  try {
    const {
      compileJS
    } = await import('./formats/gjs/index.js');
    return await compileJS(gjsInput, importMap);
  } catch (error) {
    return {
      error: error,
      name: 'unknown'
    };
  }
}
async function compileHBS(hbsInput, options) {
  try {
    const {
      compileHBS
    } = await import('./formats/hbs.js');
    return compileHBS(hbsInput, options);
  } catch (error) {
    return {
      error: error,
      name: 'unknown'
    };
  }
}
async function extractScope(liveCode, options) {
  const scope = [];
  const hbs = liveCode.filter(code => code.lang === 'hbs');
  const js = liveCode.filter(code => ['js', 'gjs'].includes(code.lang));
  if (js.length > 0) {
    const compiled = await compileGJSArray(js, options?.importMap);
    await Promise.all(compiled.map(async info => {
      // using web worker + import maps is not available yet (need firefox support)
      // (and to somehow be able to point at npm)
      //
      // if ('importPath' in info) {
      //   return scope.push({
      //     moduleName: name,
      //     component: await import(/* webpackIgnore: true */ info.importPath),
      //   });
      // }

      return scope.push(info);
    }));
  }
  for (const {
    code
  } of hbs) {
    const compiled = await compileHBS(code, {
      scope: options?.topLevelScope
    });
    scope.push(compiled);
  }
  return scope;
}
async function compileMD(glimdownInput, options) {
  const topLevelScope = options?.topLevelScope ?? {};
  let rootTemplate;
  let liveCode;
  let scope = [];

  /**
   * Step 1: Convert Markdown To HTML (Ember).
   *
   *         The remark plugin, remark-code-extra also extracts
   *         and transforms the code blocks we care about.
   *
   *         These blocks will be compiled through babel and eval'd so the
   *         compiled rootTemplate can invoke them
   */
  try {
    const {
      parseMarkdown
    } = await import('./formats/markdown.js');
    const {
      templateOnlyGlimdown,
      blocks
    } = await parseMarkdown(glimdownInput, {
      CopyComponent: options?.CopyComponent,
      ShadowComponent: options?.ShadowComponent,
      remarkPlugins: options?.remarkPlugins,
      rehypePlugins: options?.rehypePlugins
    });
    rootTemplate = templateOnlyGlimdown;
    liveCode = blocks;
  } catch (error) {
    return {
      error: error,
      name: 'unknown'
    };
  }

  /**
   * Step 2: Compile the live code samples
   */
  if (liveCode.length > 0) {
    try {
      scope = await extractScope(liveCode, options);
    } catch (error) {
      console.info({
        scope
      });
      console.error(error);
      return {
        error: error,
        rootTemplate,
        name: 'unknown'
      };
    }
  }

  /**
   * Make sure non of our snippets errored
   *
   * TODO: for these errors, report them differently so that we
   * can render the 'Ember' and still highlight the correct line?
   * or maybe there is a way to highlight in the editor instead?
   */
  for (const {
    error,
    component
  } of scope) {
    if (!component) {
      if (error) {
        return {
          error,
          rootTemplate,
          name: 'unknown'
        };
      }
    }
  }

  /**
   * Step 4: Compile the Ember Template
   */
  try {
    const localScope = scope.reduce((accum, {
      component,
      name
    }) => {
      accum[invocationName(name)] = component;
      return accum;
    }, {});
    return await compileHBS(rootTemplate, {
      moduleName: 'DynamicRootTemplate',
      scope: {
        ...topLevelScope,
        ...localScope
      }
    });
  } catch (error) {
    return {
      error: error,
      rootTemplate,
      name: 'unknown'
    };
  }
}

export { compileGJS, compileHBS, compileMD };
//# sourceMappingURL=formats.js.map
